import React from "react";
import Typography from "@material-ui/core/Typography";

export default function DivisionIdentityCmp(props: any) {
  return (
    <div
      id="division"
      style={{
        width: "100%",
        margin: "auto",
        background: props.color ? props.color : "#fff",
        marginTop: props.marginTop ? props.marginTop : '-2vh'
      }}
    >
      <span

        className="colorTitle fontWeight textFont16 mbottom10 "
        style={{
          marginTop: '-10px', marginRight: '30px', background: "#fff", paddingRight: '5px',
          paddingLeft: '5px'
        }}
      >
        {props.title}
      </span>

      <div >{props.child}</div>
    </div>
  );
}
